
const dateMask = "99/99/9999"

export const datasFields = [
    {key: "valorNominal", label: "Valor Nominal", required: true, md: 4, type: "number", inputProps: {step: "0.01"}, defaultValue: 0},
    {key: "dataEmissao", label: "Data Emissão", required: true, md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900"},
    {key: "dataIntegralizacao", label: "Data 1ª Integralização", required: true, md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900"},
    {key: "dataVencimento", label: "Data Vencimento", required: true, md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null},
    {key: "dataRentabilidadeInicio", label: "Data Rentabilidade Início", required: true, md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null},
    {key: "dataRentabilidadeFim", label: "Data Rentabilidade Fim", required: true, md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null},
    {
        key: "frequenciaJuros",
        label: "Frequência Juros",
        required: true,
        md: 4,
        type: "select",
        defaultValue: 1,
        options: [
            { value: 0, label: "Zero Cupom" },
            { value: 1, label: "Mensal" },
            { value: 2, label: "Bimestral" },
            { value: 3, label: "Trimestral" },
            { value: 4, label: "Quadrimestral" },
            { value: 6, label: "Semestral" },
            { value: 12, label: "Anual" },
            { value: -1, label: "Variável" },
        ],
    },
    {
        key: "frequenciaAmortizacao",
        label: "Frequência Amortização",
        required: true,
        md: 4,
        type: "select",
        defaultValue: 1,
        options: [
            { value: 0, label: "Bullet" },
            { value: 1, label: "Mensal" },
            { value: 2, label: "Bimestral" },
            { value: 3, label: "Trimestral" },
            { value: 4, label: "Quadrimestral" },
            { value: 6, label: "Semestral" },
            { value: 12, label: "Anual" },
            { value: -1, label: "Variável" },
        ],
    },
    {key: "dataInicioPagamentoJuros", label: "Data Início Pagamento Juros", required: true, md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null},
    {key: "dataInicioPagamentoAmortizacao", label: "Data Início Pagamento Amortização", required: true, md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null},
    {key: "dataCarenciaRecompra", label: "Data Carencia Recompra", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900"},
    {key: "frequenciaRecompra", label: "Frequência Recompra", md: 4, type: "number", inputProps: {step: "0.01"}, defaultValue: 0},

]